<template>
  <div class="video_list_container" :style="{ height }">
    <!-- 标签名称 -->
    <p v-if="!noData" class="label_title">{{ title || defaultText }}</p>
    <div v-if="!noData" class="video_content">
      <!-- 视频列表 -->
      <div class="video_list">
        <div
          class="video_item"
          v-for="(item, index) in list"
          :key="item.id"
          :class="{ active: index === currentIndex }"
          @click="clickItem(item, index)"
        >
          <p class="video_snapshot">
            <img :src="item.snapshot" alt />
            <span>{{
              (item.total && $utils.formatTime1(item.total)) ||
              $utils.formatTime1(item.end - item.start)
            }}</span>
          </p>
          <dl>
            <dt>{{ item.name || defaultText }}</dt>
            <dd>
              <p class="video_duration AkrobatR">
                {{ $utils.formatTime1(item.start) }} -
                {{ $utils.formatTime1(item.end) }}
              </p>
              <p class="video_date AkrobatR">
                {{ $utils.formatTime("YYYY/MM/DD", item.date) }}
              </p>
            </dd>
          </dl>
        </div>
      </div>
      <!-- 视频播放区域 -->
      <div class="video_player_cont">
        <div class="video_player">
          <cl-video-clips
            ref="videoRef"
            video-type="normal"
            :visible.sync="videoVisible"
            :title="title"
            :video-list="list"
            @change-video-index="changeVideoIndex"
          ></cl-video-clips>
        </div>
      </div>
    </div>
    <!-- 暂无数据 -->
    <cl-no-data
      v-if="noData"
      height="240px"
      text="暂无短片"
      img-type="video"
    ></cl-no-data>
  </div>
</template>

<script>
/**
 * ComponentName: 视频列表播放器组件
 * Created Date:2022/5/25
 * Author: haogang·du
 * Modify:
 * 组件说明：
 *  该组件适用于视频列表及播放视频
 * eg:
 *     <cl-video-list-play title="" video-list=[]></cl-video-list-play>
 */
export default {
  name: "cl-video-list-play",
  props: {
    // 组件高度
    height: {
      type: String,
      default: "300px",
    },
    // 标签名称
    title: {
      type: String,
      default: "",
    },
    // 当前的视频列表
    list: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    // 无数据
    noData() {
      let boolean = !this.list.length;
      return boolean;
    },
  },
  watch: {
    list: {
      handler(newVal) {
        if (newVal && newVal.length) {
          this.videoVisible = false;
          // 有视频数据时,让视频弹框显示
          this.$nextTick(() => {
            this.videoVisible = true;
          });
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      defaultText: "-", // 默认占位符
      currentIndex: 0, // 当前播放视频的index下标
      videoVisible: false, // 视频弹框
    };
  },
  methods: {
    // 点击列表中的视频时
    clickItem(item, index) {
      // 播放当前视频
      this.$refs.videoRef && this.$refs.videoRef.playVideo(item, index);
    },
    // 当前播放视频的index改变时
    changeVideoIndex(index) {
      this.currentIndex = index || 0;
    },
  },
};
</script>

<style lang='scss' scoped>
.video_list_container {
  margin: 0 24px;
  background: #fff;
  border-radius: $base-border-radius-mini;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  .label_title {
    font-size: 16px;
    line-height: 22px;
    padding: 24px 0 0 32px;
    color: $base-font-major;
  }
  .video_content {
    height: calc(100% - 45px);
    display: flex;
    .video_list {
      // width: 595px;
      width: 50%;
      height: 100%;
      padding: 16px 24px;
      padding-bottom: 0;
      box-sizing: border-box;
      overflow-y: auto;
      .video_item {
        width: 100%;
        height: 76px;
        padding: 16px 24px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        border-bottom: 1px solid $base-border-color-one;
        cursor: pointer;
        &:hover,
        &.active {
          border-radius: 2px;
          background: $base-blue-linear;
          dl,
          dt {
            color: #fff;
          }
        }
        .video_snapshot {
          width: 100px;
          height: 56px;
          position: relative;
          margin-right: 24px;
          img {
            width: 100%;
            height: 100%;
            border-radius: $base-border-radius-mini;
          }
          span {
            font-family: "AkrobatRegular";
            font-size: 12px;
            line-height: 20px;
            position: absolute;
            right: 8px;
            bottom: 0;
            color: #fff;
          }
        }
        dl {
          flex: 1;
          display: flex;
          align-items: center;
          color: $base-font-minor;
          font-size: 14px;
          line-height: 20px;
          dt {
            padding-right: 50px;
            color: $base-font-major;
            box-sizing: border-box;
            flex: 1;
            width: 205px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            word-break: break-all;
          }
          dd {
            display: flex;
            align-items: center;
            p.video_duration {
              font-size: 16px;
              width: 100px;
            }
            p.video_date {
              font-size: 16px;
            }
          }
        }
      }
    }
    .video_player_cont {
      width: 574px;
      height: 100%;
      overflow: auto;
    }
    .video_player {
      // width: calc(100% - 595px);
      width: 574px;
      height: 338px;
      box-sizing: border-box;
      overflow: hidden;
    }
  }
}
</style>

